export default {"src":"/_next/static/media/lower-campaign-pain.e9c73c74.svg","height":509,"width":850,"blurWidth":0,"blurHeight":0};